import styled from 'styled-components'

const Container = styled.div<TSFixMe>`
  margin: 0 0 20px;
`

const Item = styled.div<TSFixMe>`
  font-size: 16px;
`

export default {
  Container,
  Item
}
